(ns app.strive-forms.question-fields.phone-number
  (:require ["mui-tel-input" :refer (MuiTelInput , matchIsValidTel)]
            [app.strive-forms.component-multi-methods :refer [show-action-btn?]]
            [app.strive-forms.events :as events ]
            [app.strive-forms.helper-functions :refer [get-button-label]]
            [app.strive-forms.styles :refer [action-button-style
                                             phone-input-warning-notification
                                             phone-number-input-secondary-style phone-number-input-style]]
            [app.strive-forms.subs :as subs]
            [app.views :refer [responsive-screen-width]]
            [re-com.core :as re-com :refer [at v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core  :as r]))


(defn valid-phone-number? [phone-number]
  (matchIsValidTel phone-number))

;unit test here (check in tala's code )
(defn- button-enabled? [phone-number phone-valid? {:keys [is_required]}]
  (or (not is_required)
      (and phone-valid? (some? phone-number))))

(defmethod show-action-btn? "phone_number" [_]
  false)

(defn phone-number-field [{:keys [field-id input-data on-submit regenerate-display-fields]}]
  (let [phone-valid? (r/atom true)
        submitted? (r/atom false)
        phone-number (r/atom (:value (get input-data (keyword field-id))))
        form-data  @(re-posh/subscribe [::subs/form-data])]

    (fn [{:keys [field field-id index selected-language theme-data form-messages current-page input-data hidden-fields display-fields]}]
      (let [country-code (r/atom (:form-filling/country-code form-data))
            default-value (:value (:default_value field))]
        [v-box
         :justify :center
         :align :center
         :gap "10px"
         :children [[v-box
                     :gap "38px"
                     :children [[:div {:class (phone-number-input-style)}
                                 [(r/adapt-react-class MuiTelInput)
                                  {:value (or
                                           @phone-number
                                           default-value)
                                   :defaultCountry  @country-code
                                   :onChange #(do (reset! phone-number %)
                                                  (reset! phone-valid? (valid-phone-number? @phone-number)))}
                                  :class (phone-number-input-secondary-style)]]]]
                    [v-box
                     :src (at)
                     :gap "48px"
                     :justify :center
                     :children [[v-box
                                 :src (at)
                                 :width  (responsive-screen-width "760px")
                                 :children [[:div {:class (phone-input-warning-notification)} (if (or (false? @submitted?) @phone-valid?) "" "phone number doesn't look right")]]]
                                [re-com/button
                                 :label (get-button-label {:index index :input-data input-data :form-messages form-messages})
                                 :class (action-button-style {:theme-data theme-data})
                                 :disabled?  (not (button-enabled? @phone-number @phone-valid? field))
                                 :on-click #(do
                                              (reset! submitted? true)
                                              (when (valid-phone-number? @phone-number)
                                                ((re-frame/dispatch [::events/update-input-local {:input-data input-data :key (keyword field-id) :value @phone-number}])
                                                 (reset! current-page (inc index))
                                                 (regenerate-display-fields
                                                  (update input-data (keyword field-id) (fn [value]
                                                                                          (assoc value :value @phone-number))))
                                                 (when (= (+ 1 index) (- (count input-data) 1))
                                                   (on-submit)))))]]]]]))))